import { render, staticRenderFns } from "./GradeCreate.vue?vue&type=template&id=1c372f49&"
import script from "./GradeCreate.vue?vue&type=script&lang=js&"
export * from "./GradeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports